import React from 'react';
import BackendPage from '../../components/page/BackendPage';
import NdcAwardConfigurations from '../../components/ndc-awards/NdcAwardConfigurations';

export default function NdcAwardsPage() {
	return (
		<BackendPage title="NDC awards">
			<NdcAwardConfigurations />
		</BackendPage>
	);
}
